import { Routes } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { CC_CONSTANTS } from './assets/constants';
import { ConcessioncontrolState } from './states/concessioncontrol.state';

import { GenericComponent } from './components/generic/generic.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { GeneralInfoComponent } from './components/general-info/general-info.component';
import { SourceStationsComponent } from './components/sourcestations/sourcestations.component';

import { MvNetworksComponent } from './components/mv-networks/mv-networks.component';
import { MvNetworksUndergroundingComponent } from './components/mv-networks-undergrounding/mv-networks-undergrounding.component';
import { MvNetworksAgesComponent } from './components/mv-networks-ages/mv-networks-ages.component';
import { LvNetworksComponent } from './components/lv-networks/lv-networks.component';
import { LvNetworksUndergroundingComponent } from './components/lv-networks-undergrounding/lv-networks-undergrounding.component';
import { LvNetworksAgesComponent } from './components/lv-networks-ages/lv-networks-ages.component';
import { TransformerOthersComponent } from './components/transformer-others/transformer-others.component';
import { MetersComponent } from './components/transformer-meters/meters.component';
import { TransformerSubstationsComponent } from './components/transformer-substations/transformer-substations.component';
import { VoltageQualityComponent } from './components/voltage-quality/voltage-quality.component';

import { SupplyContinuityComponent } from './components/supply-continuity/supply-continuity.component';
import { SupplyContinuityBCriterionComponent } from './components/supply-continuity-b-criterion/supply-continuity-b-criterion.component';
import { SupplyContinuityOutagesComponent } from './components/supply-continuity-outages/supply-continuity-outages.component';
import { SupplyContinuityIncidentologyComponent } from './components/supply-continuity-incidentology/supply-continuity-incidentology.component';
import { ExpensesInvestmentsComponent } from './components/expenses-investments/expenses-investments.component';
import { ExpensesMaintenanceComponent } from './components/expenses-maintenance/expenses-maintenance.component';
import { AccountingIndicatorsComponent } from './components/accounting-indicators/accounting-indicators.component';
import { OperatingAccountComponent } from './components/operating-account/operating-account.component';

import { EnedisUsersComponent } from './components/enedis-users/enedis-users.component';
import { EnedisProducersComponent } from './components/enedis-producers/enedis-producers.component';
import { EnedisConnectionsComponent } from './components/enedis-connections/enedis-connections.component';
import { EnedisQualityComponent } from './components/enedis-quality/enedis-quality.component';
import { EnedisClaimsComponent } from './components/enedis-claims/enedis-claims.component';

import { EdfTrvComponent } from './components/edf-trv/edf-trv.component';
import { EdfQualityComponent } from './components/edf-quality/edf-quality.component';
import { EdfClaimsComponent } from './components/edf-claims/edf-claims.component';
import { EdfPovertyComponent } from './components/edf-poverty/edf-poverty.component';
import { AccountingRightsComponent } from './components/accounting-rights/accounting-rights.component';

export const concessionControlRoutes: Routes = [
    {
        path: '',
        providers: [importProvidersFrom(NgxsModule.forFeature([ConcessioncontrolState]))],
        children: [
            {
                path: '',
                component: WelcomeComponent,
                data: { ...CC_CONSTANTS.welcome },
            },
            {
                path: CC_CONSTANTS.welcome.path,
                component: WelcomeComponent,
                data: { ...CC_CONSTANTS.welcome },
            },
            {
                path: CC_CONSTANTS.generalInfo.path,
                component: GeneralInfoComponent,
                data: { ...CC_CONSTANTS.generalInfo },
            },
            {
                path: CC_CONSTANTS.sourceStations.path,
                component: SourceStationsComponent,
                data: { ...CC_CONSTANTS.sourceStations },
            },
            {
                path: CC_CONSTANTS.mvNetworks.path,
                component: MvNetworksComponent,
                data: { ...CC_CONSTANTS.mvNetworks, activeTab: 'undergrounding' },
                children: [
                    {
                        path: '',
                        redirectTo: CC_CONSTANTS.mvNetworks.tabs.undergrounding.path,
                        pathMatch: 'full',
                    },
                    {
                        path: CC_CONSTANTS.mvNetworks.tabs.undergrounding.path,
                        component: MvNetworksUndergroundingComponent,
                        data: { ...CC_CONSTANTS.mvNetworks },
                    },
                    {
                        path: CC_CONSTANTS.mvNetworks.tabs.aging.path,
                        component: MvNetworksAgesComponent,
                        data: { ...CC_CONSTANTS.mvNetworks },
                    },
                ],
            },
            {
                path: CC_CONSTANTS.lvNetworks.path,
                component: LvNetworksComponent,
                data: { ...CC_CONSTANTS.lvNetworks, activeTab: 'undergrounding' },
                children: [
                    {
                        path: '',
                        redirectTo: CC_CONSTANTS.lvNetworks.tabs.undergrounding.path,
                        pathMatch: 'full',
                    },
                    {
                        path: CC_CONSTANTS.lvNetworks.tabs.undergrounding.path,
                        component: LvNetworksUndergroundingComponent,
                        data: { ...CC_CONSTANTS.lvNetworks, activeTab: 'undergrounding' },
                    },
                    {
                        path: CC_CONSTANTS.lvNetworks.tabs.aging.path,
                        component: LvNetworksAgesComponent,
                        data: { ...CC_CONSTANTS.lvNetworks, activeTab: 'aging' },
                    },
                ],
            },
            {
                path: CC_CONSTANTS.transformerStations.path,
                component: TransformerOthersComponent,
                data: { ...CC_CONSTANTS.transformerStations, activeTab: 'substationsTransformers' },
                children: [
                    {
                        path: '',
                        redirectTo:
                            CC_CONSTANTS.transformerStations.tabs.substationsTransformers.path,
                        pathMatch: 'full',
                    },
                    {
                        path: CC_CONSTANTS.transformerStations.tabs.substationsTransformers.path,
                        component: TransformerSubstationsComponent,
                        data: {
                            ...CC_CONSTANTS.transformerStations,
                            activeTab: 'substationsTransformers',
                        },
                    },
                    {
                        path: CC_CONSTANTS.transformerStations.tabs.meters.path,
                        component: MetersComponent,
                        data: { ...CC_CONSTANTS.transformerStations, activeTab: 'meters' },
                    },
                ],
            },
            {
                path: CC_CONSTANTS.continuityQuality.path,
                component: SupplyContinuityComponent,
                data: { ...CC_CONSTANTS.continuityQuality, activeTab: 'BCriterion' },
                children: [
                    {
                        path: '',
                        redirectTo: CC_CONSTANTS.continuityQuality.tabs.bCriterion.path,
                        pathMatch: 'full',
                    },
                    {
                        path: CC_CONSTANTS.continuityQuality.tabs.bCriterion.path,
                        data: {
                            ...CC_CONSTANTS.continuityQuality,
                            activeTab: 'BCriterion',
                        },
                        component: SupplyContinuityBCriterionComponent,
                    },
                    {
                        path: CC_CONSTANTS.continuityQuality.tabs.outages.path,
                        data: {
                            ...CC_CONSTANTS.continuityQuality,
                            activeTab: 'outages',
                        },
                        component: SupplyContinuityOutagesComponent,
                    },
                    {
                        path: CC_CONSTANTS.continuityQuality.tabs.incidentology.path,
                        data: {
                            ...CC_CONSTANTS.continuityQuality,
                            activeTab: 'incidentology',
                        },
                        component: SupplyContinuityIncidentologyComponent,
                    },
                ],
            },
            {
                path: CC_CONSTANTS.voltageQuality.path,
                component: VoltageQualityComponent,
                data: { ...CC_CONSTANTS.voltageQuality },
            },
            {
                path: CC_CONSTANTS.investments.path,
                component: ExpensesInvestmentsComponent,
                data: { ...CC_CONSTANTS.investments },
            },
            {
                path: CC_CONSTANTS.maintenanceCost.path,
                component: ExpensesMaintenanceComponent,
                data: { ...CC_CONSTANTS.maintenanceCost },
            },
            {
                path: CC_CONSTANTS.kpis.path,
                component: AccountingIndicatorsComponent,
                data: { ...CC_CONSTANTS.kpis },
            },
            {
                path: CC_CONSTANTS.grantorRights.path,
                component: AccountingRightsComponent,
                data: { ...CC_CONSTANTS.grantorRights },
            },
            {
                path: CC_CONSTANTS.operatingAccount.path,
                component: OperatingAccountComponent,
                data: { ...CC_CONSTANTS.operatingAccount },
            },
            {
                path: CC_CONSTANTS.energyUsers.path,
                component: EnedisUsersComponent,
                data: { ...CC_CONSTANTS.energyUsers },
            },
            {
                path: CC_CONSTANTS.energyProducers.path,
                component: EnedisProducersComponent,
                data: { ...CC_CONSTANTS.energyProducers },
            },
            {
                path: CC_CONSTANTS.connections.path,
                component: EnedisConnectionsComponent,
                data: { ...CC_CONSTANTS.connections },
            },
            {
                path: CC_CONSTANTS.enedisQuality.path,
                component: EnedisQualityComponent,
                data: { ...CC_CONSTANTS.enedisQuality },
            },
            {
                path: CC_CONSTANTS.enedisClaims.path,
                component: EnedisClaimsComponent,
                data: { ...CC_CONSTANTS.enedisClaims },
            },
            {
                path: CC_CONSTANTS.trvUsers.path,
                component: EdfTrvComponent,
                data: { ...CC_CONSTANTS.trvUsers },
            },
            {
                path: CC_CONSTANTS.edfQuality.path,
                component: EdfQualityComponent,
                data: { ...CC_CONSTANTS.edfQuality },
            },
            {
                path: CC_CONSTANTS.edfClaims.path,
                component: EdfClaimsComponent,
                data: { ...CC_CONSTANTS.edfClaims },
            },
            {
                path: CC_CONSTANTS.energyPoverty.path,
                component: EdfPovertyComponent,
                data: { ...CC_CONSTANTS.energyPoverty },
            },
            /*
            {
                path: CC_CONSTANTS.exportReport.path,
                component: GenericComponent,
                data: { ...CC_CONSTANTS.exportReport },
            },*/
        ],
    },
];
